import { Pipe, PipeTransform } from '@angular/core';
import { Media } from '@digilize/shared/definitions/src';
import { ResizeFit, resizedMediaUrl } from '@digilize/shared/utils/helpers/src';

/**
 * Template side of `resizedMediaUrl`. Arguments are primitives on purpose — an options object
 * literal in a template is a new reference on every check, which would defeat the pipe's purity.
 */
@Pipe({
  name: 'resizedMedia',
  standalone: true,
})
export class ResizedMediaPipe implements PipeTransform {
  transform(media: Media | null | undefined, width?: number, height?: number, fit?: ResizeFit): string {
    return resizedMediaUrl(media, width, height, fit);
  }
}
